import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SharedModule } from './shared/shared.module';
import { HomeModule } from './home/home.module';
import { FurnitureModule } from './furniture/furniture.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { CustomerModule } from 'src/app/customer/customer.module';
import { UserModule } from 'src/app/user/user.module';
import { ProjectModule } from './project/project.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SnackbarModule } from './snackbar/snackbar.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslatePaginatorService } from './shared/translatePaginator/translate-paginator.service';
import { NavigationModule } from './navigation/navigation.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ManufacturerModule } from './manufacturer/manufacturer.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { UploadComponent } from './upload/upload/upload.component';
import { DragAndDropDirective } from './upload/upload/drag-and-drop.directive';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LOCALE_ID } from '@angular/core';
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: 'outlines-mr-web.azurewebsites.net' //'localhost' // or 'your.domain.com' // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
  },
  palette: {
    popup: {
      background: '#1E5B8C'
    },
    button: {
      background: '#fff'
    }
  },
  theme: 'classic',
  type: 'info'
};

@NgModule({
  declarations: [AppComponent, UploadComponent, DragAndDropDirective],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule,
    BrowserAnimationsModule,
    SharedModule,
    HomeModule,
    FurnitureModule,
    MatSidenavModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatDialogModule,
    CustomerModule,
    UserModule,
    ManufacturerModule,
    SnackbarModule,
    NgbModule,
    ProjectModule,
    HttpClientModule,
    NavigationModule,
    MatTableModule,
    MatSortModule,
    MatProgressBarModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: TranslatePaginatorService,
    }, {
      provide: LOCALE_ID,
      useValue: 'de'
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
